<template>
	<template v-if="measurements">
	<b-btn size="sm" @click="openMachineMeasurementsModal = true">history</b-btn>
	<b-modal
			v-model="openMachineMeasurementsModal"
			title="Maschinenmaße History"
			centered
			hide-header
			hide-footer
			style="min-width: 1200px">
	<div>
		<h3>Maschinenmesswerte - Verlaufsübersicht</h3>
		<table class="table table-striped">
			<thead>
				<tr>
					<th>Produkt-Gewicht</th>
					<th>Paket-Gewicht</th>
					<th>Produkt-Länge (cm)</th>
					<th>Produkt-Breite (cm)</th>
					<th>Produkt-Höhe (cm)</th>
					<th>Paket-Länge (cm)</th>
					<th>Paket-Breite (cm)</th>
					<th>Paket-Höhe (cm)</th>
					<th>Mess-Datum</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="measurement in measurements" :key="measurement.date">
					<td>{{ measurement.weightProduct }}</td>
					<td>{{ measurement.weightCarton }}</td>
					<td>{{ convertMMtoCM(measurement.lengthProduct) }}</td>
					<td>{{ convertMMtoCM(measurement.widthProduct) }}</td>
					<td>{{ convertMMtoCM(measurement.heightProduct) }}</td>
					<td>{{ convertMMtoCM(measurement.lengthCarton) }}</td>
					<td>{{ convertMMtoCM(measurement.widthCarton) }}</td>
					<td>{{ convertMMtoCM(measurement.heightCarton) }}</td>
					<td>{{ moment(measurement.date).format('DD.MM.YYYY HH:mm') }}</td>
				</tr>
			</tbody>
		</table>
	</div>
	</b-modal>
	</template>
</template>

<script>
export default {
	name: "MachineMeasurementsHistoryTable",
	props: {
		measurements: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			openMachineMeasurementsModal: false,
		};
	},
	methods: {
		//MM = milimeters / machine measurements
		convertMMtoCM(lengthInMM)
		{
			if(lengthInMM == null) return null;
			return (lengthInMM / 10).toLocaleString("de-DE");
		},
	},
	created() {
		// console.log(this.measurements)
	},
	mounted(){
		// console.log(this.measurements)

	}
}
</script>

<style scoped>

</style>